/* Class and set of functions for communication with Feide and Dataporten */
import dayjs from '@/plugins/dayjs.js'
import { fetchWithTimeout, fetchErrorFields } from '@/lib/fetchWithTimeout'

const UDIR_ENRICH_TIMEOUT_MS = 20000
// import os from 'os'

const GREPVersion =
  '/kl06/v201906/' /* REMEBER TO UPDATE sa-learner and GREP functions ! */
const GREPDataType = 'fagkoder'
const GREPKompetanseMaalSett = 'kompetansemaalsett-lk20'
const LAEREPLANER = 'laereplaner-lk20'
const GREPStatusPublisert =
  'https://data.udir.no/kl06/v201906/status/status_publisert'

export class UdirTools {
  constructor() {
    console.log('---------------UdirTools----------- Constructor ')
    this.udirAPIServer = 'https://data.udir.no'
  }

  /* Adds kmsKode (from Udir) to the Feide U-groups. Always resolves:
     - [] for higher education (no go_type / fc:fs groups) - as before
     - otherwise ALL u-groups, with kmsKode set where Udir had one. Groups without a GREP code or where the
       Udir lookup fails are kept (without kmsKode) - they used to be skipped, which left the promise
       unresolved (login hang) or created the educator without those subjects.
     A safety timeout resolves with what has been enriched so far. */
  getUdirEnrichUGroup(uGroups) {
    return new Promise((resolve) => {
      const groups = (Array.isArray(uGroups) ? uGroups : []).filter(
        (item) => item !== undefined && item !== null
      )
      if (groups.length === 0) {
        console.warn('NO UGROUPS')
        resolve([])
        return
      }
      if (
        !groups[0].go_type ||
        groups.some(
          (item) => item.type === 'fc:fs:prg' || item.type === 'fc:fs:emne'
        )
      ) {
        /* WE HAVE HigherEducations, since HE have "membership" structure
           And no codes for accessing GREP or curiculum information.
        */
        console.warn('Higher Education')
        resolve([])
        return
      }
      let settled = false
      let timer = null
      const finish = () => {
        if (settled) {
          return
        }
        settled = true
        clearTimeout(timer)
        resolve(groups)
      }
      timer = setTimeout(() => {
        console.warn(
          'getUdirEnrichUGroup timed out - continuing with the kmsKodes found so far'
        )
        finish()
      }, UDIR_ENRICH_TIMEOUT_MS)
      const lang = localStorage.getItem('lang')
      Promise.all(
        groups.map((item, index) => {
          const code = item.grep?.code
          if (!code) {
            return Promise.resolve()
          }
          return this.getUdirFagKodeFromFeideGrepCode(code, index, lang)
            .then((res) => {
              const result = res?.result
              if (result && result.length > 0) {
                item.kmsKode = result
              } else {
                console.warn(
                  '====== NO DATA FROM OPPLAERINGSFAG ==(%s)==',
                  code
                )
              }
            })
            .catch((error) => {
              console.error(
                '*** ERROR *** this.getUdirFagKodeFromFeideGrepCode had some problems',
                error
              )
            })
        })
      ).then(finish)
    })
  }

  async getUdirFagKodeFromFeideGrepCode(code, index, currentLang) {
    return new Promise((resolve, reject) => {
      // console.log('getUdirFagKodeFromFeideGrepCode got called : ' + code)
      let queryRes = {}
      let codeQuery = GREPDataType + '/' + code
      /* console.info(
        'QUERY IS: (%s)',
        this.udirAPIServer + GREPVersion + GREPDataType + '/' + code
      )
      */
      this.getHTTPUdirLanguage(
        this.udirAPIServer + GREPVersion + codeQuery,
        currentLang
      )
        .then((response) => {
          queryRes = response
          // from http://data.udir.no/kl06/MAT0010
          /*
          console.info(
            'QUERY WAS: (%s)',
            this.udirAPIServer + GREPVersion + GREPDataType + '/' + code
          )
          console.info(
            '====== RESPONSE ====== opplaeringsfag (%s) (%i), (%s)',
            code,
            index,
            currentLang
          )
          */
          //  console.log(response.data)
          let opplaeringsfag = response.data.opplaeringsfag || []
          //  console.log('OPPLÆRINGSFAG LENGTH (%i)', opplaeringsfag.length)
          if (opplaeringsfag.length === 0) {
            // FAK0007 is not a "opplaeringsfag"
            resolve({
              result: [],
              index: index
            })
          } else {
            let isPublisert = false
            for (let i = 0; i < opplaeringsfag.length; i++) {
              //            opplaeringsfag.forEach(value => {
              let value = opplaeringsfag[i]
              // console.log('=== STATUS CODE (%s)', value.status)
              if (checkValidOpplaeringsfag(value)) {
                isPublisert = true
                this.getUdirFagKode(value)
                  .then((udirkode) => {
                    isPublisert = true
                    resolve({
                      result: udirkode,
                      index: index
                    })
                    return
                  })
                  .catch((error) => {
                    reject(new Error(error))
                  })
              }
            } // for
            if (!isPublisert) {
              /* Only if none of the previous opplaeringsfagene is published. ie. all is not published, and are replaced*/
              //    console.log('>>>>>>>>>>> NOT PUBLISERT >>>>>>>>>>>>>> (%s)', code)
              //    console.log('>>>>>>>>>>>>>>>>>> %s <<<<<<<<<<<<<<', notPublisert)
              //    console.log(JSON.stringify(queryRes))
              /* If none of the 'opplaeringsfag' is publised, it means that an old code has been used. And we should check for erstattes-av instead. */
              /* If we get here - it means that the "resolve" or "reject" has been triggered, and that we should look for 'erstattes-av' */
              let erstattesAv = queryRes.data['erstattes-av'] || []
              let erstattesUrl = ''
              //    console.log('ERSTATTES AV LENGTH (%i)', erstattesAv.length)
              for (let i = 0; i < erstattesAv.length; i++) {
                // erstattesAv.forEach(value => {
                let value = erstattesAv[i]
                if (value.status === GREPStatusPublisert) {
                  erstattesUrl = value['url-data']
                }
              } // forEach
              //    console.log('ERSTATTTES AV URL (%s)', erstattesUrl)
              if (erstattesUrl !== '') {
                this.getHTTPUdirLanguage(erstattesUrl, currentLang)
                  .then((updateResult) => {
                    //       console.log('========== UPDATE RESULT (%s)', erstattesUrl)
                    //       console.log(JSON.stringify(updateResult))
                    if (updateResult.data === null) {
                      resolve({
                        result: [],
                        index: index
                      })
                    } else {
                      let opplaeringsfag =
                        updateResult.data.opplaeringsfag || []
                      /*      console.log(
                        'OPPLÆRINGSFAG OPPDATERT LENGTH (%i)',
                        opplaeringsfag.length
                      )
                      */
                      if (opplaeringsfag.length === 0) {
                        // FAK0007 is not a "opplaeringsfag"
                        resolve({
                          result: [],
                          index: index
                        })
                      } else {
                        isPublisert = false
                        for (let i = 0; i < opplaeringsfag.length; i++) {
                          // opplaeringsfag.forEach(value => {
                          let value = opplaeringsfag[i]
                          //       console.log('=== STATUS CODE (%s)', value.status)
                          if (value.status === GREPStatusPublisert) {
                            isPublisert = true
                            this.getUdirFagKode(value)
                              .then((udirkode) => {
                                resolve({
                                  result: udirkode,
                                  index: index
                                })
                              })
                              .catch((error) => {
                                reject(new Error(error))
                              })
                          } // if publisert
                        } // foreach
                        if (!isPublisert) {
                          resolve({
                            result: [],
                            index: index
                          })
                        }
                      } // else length >0
                    } // else has resultData
                  }) //then HTTP
                  .catch((error) => {
                    console.error(
                      '*** ERROR *** getUdirFagKodeFromFeideGrepCode replaced with had problems:',
                      error
                    )
                    reject(
                      new Error(
                        '*** ERROR *** getUdirFagKodeFromFeideGrepCode replaced with had problems:',
                        error
                      )
                    )
                  })
              } else {
                // Not published and not replaced - nothing to find (this path used to never resolve)
                resolve({
                  result: [],
                  index: index
                })
              } // if has erstatterUrl
            } // if is publisert
          } // if opplaeringsfag
        }) // then first HTTP
        .catch((error) => {
          console.error(
            '*** ERROR *** getUdirFagKodeFromFeideGrepCode had some problems : ' +
              error
          )
          reject(
            new Error(
              '*** ERROR *** getUdirFagKodeFromFeideGrepCode had some problems : ',
              error
            )
          )
        })
    }) // promise
  }

  getUdirFagKode(urlFag) {
    // from http://data.udir.no/kl06/MAT1Z34
    //  console.log('getUdirFagKode got called (%j)', urlFag)
    // console.log(urlFag)
    return new Promise((resolve, reject) => {
      let newUrl = fixHttpsUrl(urlFag['url-data'])
      this.getHTTPUdir(newUrl)
        .then((result) => {
          //    console.info('====== RESULT ====== getUdirFagKode')
          // console.log(result.data)
          let lareplanreferanse = result.data?.['laereplan-referanse'] || []
          for (let i = 0; i < lareplanreferanse.length; i++) {
            //          lareplanreferanse.forEach((value, index, array) => {
            let value = lareplanreferanse[i]
            let kms = value['tilhoerende-kompetansemaalsett']
            //   console.log('--- KMS --- ')
            //   console.log(kms)
            // console.log(value.status)
            if (checkValidLareplan(value)) {
              ;(kms || []).forEach((value1) => {
                //     console.log('======= VALUE2 KODE (' + value1.kode + ')')
                resolve(value1.kode)
              })
            }
          } // for each
          // No valid læreplan found - resolve empty (an earlier resolve above wins otherwise)
          resolve('')
        })
        .catch((error) => {
          console.error(
            '*** ERROR *** getUdirFagKode had some problems !' + error
          )
          reject(
            new Error('*** ERROR *** getUdirFagKode had some problems !', error)
          )
        })
    })
  }

  async getGrepDataFromKompetansemaal(kms, currentLang) {
    // kms = testBrukerKms(kms)
    console.log(
      'getGREP DATA FROM KOMPETANSEMÅL got called (%s), lang(%s)',
      kms,
      currentLang
    )
    return new Promise((resolve) => {
      let searchCode = GREPKompetanseMaalSett + '/' + kms
      //   console.log('SEARCH (%s)', this.udirAPIServer + GREPVersion + searchCode)
      this.getHTTPUdirLanguage(
        this.udirAPIServer + GREPVersion + searchCode,
        currentLang
      ) // code +
        .then((response) => {
          let grepData = response.data
          //  console.log(grepData)
          console.log('=== GREP RESPONSE : ', grepData)
          //  console.log(JSON.stringify(grepData.kompetansemaal))
          let fixedTitles = []
          console.log(
            'PROCESSING CURRICULUM INFORMATION FOR (%s) lang(%s)',
            kms,
            currentLang
          )
          //          for (const comp in grepData.kompetansemaal) {
          for (let i = 0; i < grepData.kompetansemaal.length; i++) {
            let competence = grepData.kompetansemaal[i] || {}
            console.log('competence:', competence)
            this.getLangTitle(competence['url-data'], currentLang).then(
              (cres) => {
                console.log('CRES : ', cres)
                grepData.kompetansemaal[i].tittel = cres
                fixedTitles.push(cres)
                if (fixedTitles.length === grepData.kompetansemaal.length) {
                  resolve(grepData.kompetansemaal)
                }
              }
            ) //getLangTitle
          } // for
        }) // GET HHTP UDIR LANGAAA
    }) // promise
  }

  getSubjectUrlFromCode(code, currentLang) {
    return new Promise((resolve, reject) => {
      if (code === 'undefined') {
        resolve({
          succes: true,
          successMsg: 'no value for code: ' + code
        })
      }
      this.getHTTPUdirLanguage(
        this.udirAPIServer + GREPVersion + GREPKompetanseMaalSett + '/' + code,
        currentLang
      )
        .then((response) => {
          let grepData = response.data['tilhoerer-laereplan'] || {}
          // console.log(grepData)
          let urlData = grepData['url-data'] || ''
          if (urlData !== '') {
            urlData = urlData + '.html'
          }
          let subjectTitle = grepData.tittel || ''
          resolve({
            url: urlData,
            tittel: subjectTitle,
            kode: grepData.kode
          })
        })
        .catch((error) => {
          console.error(
            'getSubjectUrlFromCode had some problems ! ' +
              error +
              ' code : ' +
              code
          )
          reject(
            new Error(
              'getSubjectUrlFromCode had some problems ! ' +
                error +
                ' code : ' +
                code
            )
          )
        })
    }) // promise
  }

  getSubjectInfo(code, currentLang) {
    return new Promise((resolve, reject) => {
      if (code === 'undefined') {
        resolve({
          succes: true,
          successMsg: 'no value for code: ' + code
        })
      }
      this.getHTTPUdirLanguage(
        this.udirAPIServer + GREPVersion + LAEREPLANER + '/' + code,
        currentLang
      )
        .then((response) => {
          let grepData = response.data['tittel'] || {}
          // console.log(grepData)
          let gData = grepData[0] || {}
          let subjectTitle = gData.verdi || ''
          resolve({
            tittel: subjectTitle
          })
        })
        .catch((error) => {
          console.error(
            'getSubjectUrlFromCode had some problems ! ' +
              error +
              ' code : ' +
              code
          )
          reject(
            new Error(
              'getSubjectUrlFromCode had some problems ! ' +
                error +
                ' code : ' +
                code
            )
          )
        })
    }) // promise
  }

  getGrepCoreElements(url, currentLang) {
    return new Promise((resolve, reject) => {
      if (url === '' || url === undefined) {
        reject('NO URL PROVIDED !')
      }
      this.getHTTPUdirLanguage(url, currentLang)
        .then((response) => {
          /*   console.log(
            'GREP CORE ELEMENTS RETURNED (%s) (%j)',
            currentLang !== 'nob',
            response.data
          )
          */
          if (currentLang !== 'nob') {
            this.getCurriculaDetailLangV1(
              response.data['tilknyttede-kjerneelementer'],
              currentLang
            ).then((tkRes) => {
              response.data['tilknyttede-kjerneelementer'] = tkRes
              this.getCurriculaDetailLang(
                response.data['tilknyttede-grunnleggende-ferdigheter'],
                currentLang
              ).then((tgfRes) => {
                response.data['tilknyttede-grunnleggende-ferdigheter'] = tgfRes
                //    console.log('>>>>>>>>>>> TILKNYTTEDE VERB')
                this.getCurriculaDetailLangV2(
                  response.data['tilknyttede-verb'],
                  currentLang
                ).then((tvRes) => {
                  response.data['tilknyttede-verb'] = tvRes
                  //     console.log('>>>>>>>>>>> BYGGER PÅ')
                  this.getCurriculaDetailLangV1(
                    response.data['bygger-paa'],
                    currentLang
                  ).then((bpRes) => {
                    response.data['bygger-paa'] = bpRes
                    /*        console.log(
                      '>>>>>>>>>>> SAMMES SOM (%j)',
                      response.data['samme-som']
                    )
                    */
                    this.getCurriculaDetailLang(
                      response.data['samme-som'],
                      currentLang
                    )
                      .then((ssRes) => {
                        //             console.log('SAMME SOM RETURNED (%j)', ssRes)
                        response.data['samme-som'] = ssRes
                      })
                      .finally(() => {
                        resolve(response)
                      })
                  })
                })
              })
            })
          } else {
            resolve(response)
          }
        })
        .catch((error) => {
          console.error(
            'getGrepCoreElements had some problems ! ' + error + ' code : '
          )
          reject(
            new Error(
              'getGrepCoreElements had some problems ! ' + error + ' code : '
            )
          )
        })
    }) // promise
  }

  getDefinitionsFromGrep(url, currentLang) {
    return new Promise((resolve, reject) => {
      if (url === '' || url === undefined) {
        reject('NO URL PROVIDED !')
      }
      this.getHTTPUdirLanguage(url, currentLang)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          console.error(
            'getDefinitionsFromGrep had some problems ! ' + error + ' code : '
          )
          reject(
            new Error(
              'getDefinitionsFromGrep had some problems ! ' + error + ' code : '
            )
          )
        })
    }) // promise
  }

  async getByggerPaaElements(url, currentLang) {
    return new Promise((resolve, reject) => {
      if (url === '' || url === undefined) {
        reject('NO URL PROVIDED !')
      }
      this.getHTTPUdirLanguage(url, currentLang)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          console.error(
            'getGrepCoreElements had some problems ! ' + error + ' code : '
          )
          reject(
            new Error(
              'getGrepCoreElements had some problems ! ' + error + ' code : '
            )
          )
        })
    }) // promise
  }

  async getLangTitle(url, webLang) {
    return new Promise((resolve) => {
      this.getHTTPUdirLanguage(url, webLang).then((result) => {
        //     console.log('getLangTitle returned: (%s) (%j)', url, result.data)
        resolve(result.data.tittel.tekst[0].verdi)
        // resolve('url')
      })
    }) // promise
  }
  async getLangDetailTitle(url, webLang) {
    return new Promise((resolve) => {
      this.getHTTPUdirLanguage(url, webLang).then((result) => {
        //    console.log('getLangTitle returned: (%j)', result)
        resolve(result.data.tittel[0].verdi)
        // resolve('url')
      })
    }) // promise
  }

  async getCurriculaDetailLang(curriculaObject, currentLang) {
    return new Promise((resolve) => {
      let objLength = curriculaObject.length
      if (objLength === 0) {
        resolve([])
      }
      let updatedObject = []
      for (let curriculaItem in curriculaObject) {
        let curr = curriculaObject[curriculaItem]
        let ref = curr.referanse
        let urlData = ref['url-data']
        this.getLangDetailTitle(urlData, currentLang).then((newTitle) => {
          curr.referanse.tittel = newTitle
          updatedObject.push(curr)
          if (objLength === updatedObject.length) {
            resolve(updatedObject)
          }
        })
      }
    }) // promise
  }

  async getCurriculaDetailLangV1(curriculaObject, currentLang) {
    return new Promise((resolve) => {
      let objLength = curriculaObject.length
      if (objLength === 0) {
        resolve([])
      }
      let updatedObject = []
      for (let curriculaItem in curriculaObject) {
        let curr = curriculaObject[curriculaItem]
        let ref = curr.referanse
        let urlData = ref['url-data']
        //    console.log('URL DATA (%s)', urlData)
        this.getLangTitle(urlData, currentLang).then((newTitle) => {
          curr.referanse.tittel = newTitle
          updatedObject.push(curr)
          if (objLength === updatedObject.length) {
            resolve(updatedObject)
          }
        })
      }
    }) // promise
  }

  async getCurriculaDetailLangV2(curriculaObject, currentLang) {
    //  console.log('getCurriculaDetailLangV2 GOT CALLED')
    //  console.log(curriculaObject)
    return new Promise((resolve) => {
      let objLength = curriculaObject.length
      if (objLength === 0) {
        resolve([])
      }
      let updatedObject = []
      for (let curriculaItem in curriculaObject) {
        let curr = curriculaObject[curriculaItem]
        // let ref = curr.referanse
        let urlData = curr['url-data']
        //  console.log('URL DATA (%s)', urlData)
        this.getLangDetailTitle(urlData, currentLang).then((newTitle) => {
          curr.tittel = newTitle
          updatedObject.push(curr)
          if (objLength === updatedObject.length) {
            resolve(updatedObject)
          }
        })
      }
    }) // promise
  }

  async getHTTPUdir(url) {
    return new Promise((resolve, reject) => {
      console.log('GET getHTTPUdir URL (%s)', url)
      let options = {
        method: 'GET',
        url: url,
        headers: {
          // 'Content-Type': 'application/json',
          'x-api-key': '9fa62fe4c6544cd3a985431451890925',
          Accept: 'application/json'
        },
        mode: 'cors',
        // timeout: 30000, // 30s // controlled by the browser
        responseType: 'json', // default
        responseEncoding: 'utf8', // default
        maxRedirects: 3, // default
        'Accept-Encoding': 'gzip, compress'
        // body: "{foo: 'bar'}" //JSON.stringify(loadData),
      }

      fetchWithTimeout(options.url, options)
        .then((response) => {
          console.log('getHTTPUdir RESPONSE IS (%j)', response)
          if (!response.ok) {
            reject({
              success: false,
              error: true,
              status: response.status,
              errorMsg: 'Udir answered ' + response.status
            })
            return
          }
          response
            .json()
            .then((result) => {
              console.log('RESULT FROM JSON IS (%j)', result)
              resolve({ success: true, data: result })
            })
            .catch((err2) => {
              console.error('RESPONSE JSON', err2)
              reject({
                success: false,
                error: true,
                errorMsg: 'Invalid JSON from Udir: ' + err2
              })
            })
        })
        .catch((error) => {
          console.error('*** ERROR *** getHTTPUdir', {
            errorMsg: error.toString()
          })
          reject({ success: false, error: true, ...fetchErrorFields(error) })
        })
    }) // promise
  }

  async getHTTPUdirLanguage(url, currentLang) {
    return new Promise((resolve, reject) => {
      let udirLang = this.getUdirLang(currentLang)
      // console.log('GET getHTTPUdir URL (%s %s)', url, udirLang)
      let options = {
        method: 'GET',
        url: url + '?lang=' + udirLang,
        headers: {
          // 'Content-Type': 'application/json',
          'x-api-key': '9fa62fe4c6544cd3a985431451890925',
          Accept: 'application/json'
        },
        mode: 'cors',
        // timeout: 30000, // 30s // controlled by the browser
        responseType: 'json', // default
        responseEncoding: 'utf8', // default
        maxRedirects: 3, // default
        'Accept-Encoding': 'gzip, compress'
        // body: "{foo: 'bar'}" //JSON.stringify(loadData),
      }
      fetchWithTimeout(options.url, options)
        .then((response) => {
          // console.log('getHTTPUdir RESPONSE IS (%j)', response)
          if (!response.ok) {
            reject({
              success: false,
              error: true,
              status: response.status,
              errorMsg: 'Udir answered ' + response.status
            })
            return
          }
          response
            .json()
            .then((result) => {
              // console.log('RESULT FROM JSON IS (%j)', result)
              resolve({ success: true, data: result })
            })
            .catch((err2) => {
              console.error('RESPONSE JSON', err2)
              reject({
                success: false,
                error: true,
                errorMsg: 'Invalid JSON from Udir: ' + err2
              })
            })
        })
        .catch((error) => {
          console.error('*** ERROR *** getHTTPUdir', {
            errorMsg: error.toString()
          })
          reject({ success: false, error: true, ...fetchErrorFields(error) })
        })
    }) // promise
  }

  getUdirLang(lang) {
    switch (lang) {
      case 'nb':
      case 'nob':
        return 'nob'
      case 'nn':
      case 'nno':
        return 'nno'
      case 'se':
        return 'sme'
      default:
        return 'eng'
    }
  }
}

function fixHttpsUrl(url) {
  //  console.log('=== fixHttpsUrl === got called (' + url + ')')
  let coreUrl = url.substring(0, 5)
  if (coreUrl === 'https') {
    return url
  } else if (coreUrl === 'http:') {
    return url.replace('http:', 'https:')
  }
}

function checkValidLareplan(lareplan) {
  // console.log('CHECK VALID LAREPLAN GOT CALLED ')
  // console.log(JSON.stringify(lareplan))
  let ks = lareplan['tilhoerende-kompetansemaalsett'] || []
  // console.log(JSON.stringify(ks))
  let kompetansesett = ks[0]
  // console.log(JSON.stringify(kompetansesett))
  let today = dayjs()
  let fromDate = kompetansesett.gyldighet['gyldig-fra'] || '0000-00-00'
  let toDate = kompetansesett.gyldighet['gyldig-til'] || '0000-00-00'
  /*
  console.log('CHECKVALID LAREPLAN:::')
  console.log(today)
  console.log(fromDate)
  console.log(toDate)
  */
  let validFrom = dayjs(fromDate)
  let validTo = dayjs(toDate)
  // console.log(validFrom)
  // console.log(validTo)
  if (kompetansesett.status !== GREPStatusPublisert) {
    // console.log('>>>>>>>>> NOT PUBLISHED <<<<<<<<<<<')
    return false
  } else {
    // status is publisert...
    if (today.isSameOrAfter(validFrom) && validTo.isSameOrAfter(today)) {
      /* console.log(
        'TEST 1 (%s)',
        today.isSameOrAfter(validFrom) && validTo.isSameOrAfter(today)
      )
*/
      return true
    } else if (today.isSameOrAfter(validFrom) && toDate === '0000-00-00') {
      /*  console.log(
        'TEST 2 (%s)',
        today.isSameOrAfter(validFrom) && toDate === '0000-00-00'
      )
      */
      return true
    } else {
      //  console.log('<<<<<<<<<<<<<<<<< F AL S E >>>>>>>>>>>>>')
      return false
    }
  }
}

function checkValidOpplaeringsfag(lareplan) {
  // console.log('CHECK VALID OPPLAERINGSFAG GOT CALLED ')
  // console.log(JSON.stringify(lareplan))
  if (lareplan.status !== GREPStatusPublisert) {
    console.log('>>>>>>>>> NOT PUBLISHED <<<<<<<<<<<')
    return false
  } else {
    let today = dayjs()
    let fromDate = lareplan.gyldighet['gyldig-fra'] || '0000-00-00'
    let toDate = lareplan.gyldighet['gyldig-til'] || '0000-00-00'
    /*  console.log('CHECKVALID LAREPLAN:::')
    console.log(today)
    console.log(fromDate)
    console.log(toDate)
    */
    let validFrom = dayjs(fromDate)
    let validTo = dayjs(toDate)
    // console.log(validFrom)
    // console.log(validTo)

    // status is publisert...
    if (today.isSameOrAfter(validFrom) && validTo.isSameOrAfter(today)) {
      /*  console.log(
        'TEST 1 (%s)',
        today.isSameOrAfter(validFrom) && validTo.isSameOrAfter(today)
      )
      */
      return true
    } else if (today.isSameOrAfter(validFrom) && toDate === '0000-00-00') {
      /* console.log(
        'TEST 2 (%s)',
        today.isSameOrAfter(validFrom) && toDate === '0000-00-00'
      )
      */
      return true
    } else if (
      fromDate === '0000-00-00' &&
      toDate === '0000-00-00' &&
      lareplan.status === GREPStatusPublisert
    ) {
      return true
    } else {
      console.log('<<<<<<<<<<<<<<<<< F AL S E >>>>>>>>>>>>>')
      return false
    }
  }
}
